var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(10) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9429",
    d: "M2.682,291.965a.665.665,0,0,0-.635.463.745.745,0,0,0,.2.8L6.3,296.954l-4.051,3.727a.737.737,0,0,0-.261.687.7.7,0,0,0,.45.563.63.63,0,0,0,.672-.173l4.638-4.263a.746.746,0,0,0,0-1.082l-4.638-4.267a.637.637,0,0,0-.424-.179Z",
    transform: "translate(-1.976 -291.965)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdownArrow.920b1d898cf16eab937d50577f591839.svg";
export { ForwardRef as ReactComponent };